import { HTMLProps } from 'react';
import s from './Checkbox.module.scss';
import { Row } from '@tanstack/react-table';
import classNames from 'classnames';

interface Props<TableData> extends HTMLProps<HTMLInputElement> {
  row: Row<TableData>;
}

export function Checkbox<TableData>({
  row: { getIsSelected, getCanSelect, getToggleSelectedHandler, id },
  disabled,
  ...rest
}: Props<TableData>) {
  return (
    <>
      <input
        {...{
          checked: getIsSelected(),
          disabled: !getCanSelect() || disabled,
          onChange: getToggleSelectedHandler(),
        }}
        className={classNames(s.checkbox, { [s.disabled]: disabled })}
        id={id}
        type="checkbox"
        {...rest}
        name="user-selection"
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={id} />
    </>
  );
}
